import { render } from "./index.vue?vue&type=template&id=ef01e6ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ef01e6ee&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef01e6ee"]])

export default __exports__